import 'vanilla-match-height';
import imageCompression from 'browser-image-compression';
import Toastify from 'toastify-js';

let ajaxBusy = 0;
function setAjaxBusy(state) {
  if (state === 'start') ajaxBusy++;
  if (state === 'end') ajaxBusy--;
  if (ajaxBusy < 0) ajaxBusy = 0;

  const buttons = document.querySelectorAll('.js-add-product, #add_to_cart');
  buttons.forEach(btn => {
    if (ajaxBusy > 0) {
      btn.style.display = 'none';
    } else {
      btn.style.display = 'flex';
    }
  });
}

function switchImage(e){
  const thumbImgSrc = e.target.closest('.images__thumbs li').getAttribute('data-img-src');
  const productImg = document.querySelector('.js-product-image img');
  if (productImg) {
    productImg.setAttribute('src', thumbImgSrc);
  }
  return;
}
function getTabs(e){
   e.preventDefault();
    const tabLink = e.target.closest('a');
    const tabsContainer = tabLink.closest('.product-tabs__selector');
    const allTabs = tabsContainer.querySelectorAll('li');
    const productTabs = tabLink.closest('.product-tabs').querySelectorAll('.product-tabs__content');
    const tabId = tabLink.getAttribute('href');

    allTabs.forEach(tab => tab.classList.remove('is-active'));
    productTabs.forEach(tabContent => tabContent.classList.remove('is-visible'));
    tabLink.closest('li').classList.add('is-active');
    const targetContent = document.querySelector(tabId);
    if (targetContent) {
      targetContent.classList.add('is-visible');
    }
    return;
}
function updateCookie(data) {
    let cookie = getCookie('gx_quotation');
    if (cookie !== undefined) {
      cookie = JSON.parse(cookie);
      const productIndex = cookie.findIndex(obj => obj.id == data.id && obj.time == data.time);
      if (productIndex === -1) {
        cookie.push(data);
      } else {
        cookie[productIndex] = data;
      }
      cookie = JSON.stringify(cookie);
    } else {
      cookie = JSON.stringify([data]);
    }
    document.cookie = `gx_quotation=${cookie}; path=/; max-age=${60 * 60 * 24 * 14}`;
  }

  function getCustomProductData() {
    let updateObj = {};
   
    const productId = parseInt(document.querySelector('.product-details').getAttribute('data-id'));


    const productName = document.querySelector('.product_title') ? document.querySelector('.product_title').textContent : '';
    const productSKU = document.querySelector('.product_sku') ? document.querySelector('.product_sku').textContent : '';

       
    const quantityElem = document.querySelector('.js-product-quantity');
    const quantity = quantityElem && quantityElem.value ? parseInt(quantityElem.value) : undefined;
    
    updateObj.product_id = productId;
    updateObj.product_name = productName;
    updateObj.product_sku = productSKU;
    
    updateObj.quantity = quantity;
    updateObj.id = `${productId}`;
    updateObj.time = Date.now();      

    return updateObj;
  }

  function removeProductFromCookie(id, time) {
    let cookie = getCookie('gx_quotation');
    if (cookie !== undefined) {
      cookie = JSON.parse(cookie);
      const productIndex = cookie.findIndex(obj => obj.id == id && obj.time == time);
      cookie.splice(productIndex, 1);
      cookie = JSON.stringify(cookie);
      document.cookie = `gx_quotation=${cookie}; path=/; max-age=${60 * 60 * 24 * 14}`;
      removeFileFromSessionStorage(id, time);
    }
  }

  function getCookie(name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  function updateSessionStorageFiles(data) {
    let files = '';
    if (sessionStorage.hasOwnProperty('gx_quotation_files')) {
      files = JSON.parse(sessionStorage.getItem('gx_quotation_files'));
      const fileIndex = files.findIndex(obj => obj.file_id == data.id && obj.time == data.time);
      if (fileIndex === -1) {
        files.push(data);
      } else {
        files[fileIndex] = data;
      }
      files = JSON.stringify(files);
    } else {
      files = JSON.stringify([data]);
    }
    sessionStorage.setItem('gx_quotation_files', files);
  }

  function removeFileFromSessionStorage(id, time) {
    if (sessionStorage.hasOwnProperty('gx_quotation_files')) {
      let files = JSON.parse(sessionStorage.getItem('gx_quotation_files'));
      const fileIndex = files.findIndex(obj => obj.file_id == id && obj.time == time);
      if (fileIndex != -1) {
        files.splice(fileIndex, 1);
        files = JSON.stringify(files);
        sessionStorage.setItem('gx_quotation_files', files);
      }
    }
  }
function handleAttachment(time) {
    return new Promise((resolve, reject) => {
      const attachmentInput = document.querySelector('.js-product-attachment input');
      const imageFile = attachmentInput ? attachmentInput.files[0] : null;
      if (!imageFile) {
        resolve();
      } else {

        const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/gif', 'application/pdf', 'application/postscript'];

        if (allowedTypes.includes(imageFile.type)) {
          getBase64(imageFile)
            .then(data => {
            
            const productData = (typeof getProductData === 'function' ? getProductData() : typeof getCustomProductData === 'function' ? getCustomProductData() : 'NULL');
              const file = {
                file_name: productData.product_sku + '_' + imageFile.name,
                file_data: data.split('base64,').pop(),
                file_type: imageFile.type,
                file_id: productData.id,
                time: time
              };
            
              updateSessionStorageFiles(file);

       
              resolve();
            })
            .catch(err => {
              console.log(err);
              reject(err);
            });
        } else {
          let options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
          };
          imageCompression(imageFile, options)
            .then((compressedFile) => {
              getBase64(compressedFile)
                .then(data => {
                  const productData = (typeof getProductData === 'function' ? getProductData() : typeof getCustomProductData === 'function' ? getCustomProductData() : '');
               
                  const file = {
                    file_name: productData.product_sku + '_' + time + '.' + compressedFile.type.split('/').pop(),
                    file_data: data.split('base64,').pop(),
                    file_type: compressedFile.type,
                    file_id: productData.id,
                    time: time
                  };
              
                  updateSessionStorageFiles(file);
                  resolve();
                })
                .catch(err => {
                  console.log(err);
                  reject(err);
                });
            })
            .catch((error) => {
              console.log(error.message);
              reject(error.message);
            });
        }
      }
    });
  }

(function() {

  const slug = jQuery('#product-js-init').data('type');
  if (slug === 'custom-product') {
 

  document.addEventListener('click', (e) => {
  const target = e.target;
    if (target.closest('.js-add-custom-product')) {    
      const quotationUrl = document.querySelector('.product-details').getAttribute('data-quotation-page');
      const data = getCustomProductData();
      handleAttachment(data.time)
        .then(() => {
          updateCookie(data);
          window.location.href = quotationUrl;
        })
        .catch(err => console.log(err));
      
      return;
    }
    // Product tabs
    if (target.closest('.product-tabs__selector a')) {
     getTabs(e);
    }

    // Thumbnail klik om productafbeelding te wijzigen
    if (target.closest('.images__thumbs li')) {
      switchImage(e);
    }

 

  });
} else {

  // Cachen van veelgebruikte elementen
  const productInfo = document.querySelector('.product__info');
  if (productInfo) {
    document.body.matchHeight({ elements: '.product__info' });
  }

  // Event listeners voor product kleuren
  const infoColors = document.querySelector('.product__info .info__colors');
  if (infoColors) {
    const colorLinks = infoColors.querySelectorAll('a');
    colorLinks.forEach(el => {
      el.addEventListener('click', (e) => {
        if (window.innerWidth < 768) e.preventDefault();
      });
      el.addEventListener('mouseenter', () => {
        const imgSrc = el.getAttribute('data-img-src');
        const url = el.getAttribute('href');
        const product = el.closest('.product');
        if (product) {
          const productImage = product.querySelector('.product__image');
          if (productImage) {
            productImage.setAttribute('href', url);
            const img = productImage.querySelector('img');
            if (img) {
              img.setAttribute('src', imgSrc);
            }
          }
          const titleLink = product.querySelector('.info__title a');
          if (titleLink) {
            titleLink.setAttribute('href', url);
          }
        }
      });
    });
  }

  // Helper-functie voor foutmeldingen
  function showError(message) {
    Toastify({
      text: message,
      duration: 2000,
      className: 'error',
      avatar: themeUrl + '/assets/images/cancel.svg',
      gravity: 'bottom',
      position: 'right'
    }).showToast();
  }

  // Eén enkele click event listener voor diverse acties
  document.addEventListener('click', (e) => {
    const target = e.target;

    // Product tabs
    if (target.closest('.product-tabs__selector a')) {
     getTabs(e);
    }

    // Thumbnail klik om productafbeelding te wijzigen
    if (target.closest('.images__thumbs li')) {
      switchImage(e);
    }

    // Product toevoegen
    if (target.closest('.js-add-product')) {
      if (!handleProduct()) {
        const quotationUrl = document.querySelector('.product-details').getAttribute('data-quotation-page');
        const data = getProductData();
        handleAttachment(data.time)
          .then(() => {
            updateCookie(data);
            window.location.href = quotationUrl;
          })
          .catch(err => console.log(err));
      }
      return;
    }

    // Product verwijderen (bevestigingsdialoog)
    if (target.closest('.js-remove-product-confirmation')) {
      document.querySelector('.js-remove-product-dialog').showModal();
      const quotationProduct = target.closest('.quotation-product');
      if (quotationProduct) {
        const id = quotationProduct.getAttribute('data-id');
        const time = quotationProduct.getAttribute('data-time');
        const removeBtn = document.querySelector('.js-remove-product');
        if (removeBtn) {
          removeBtn.setAttribute('data-id', id);
          removeBtn.setAttribute('data-time', time);
        }
      }
      return;
    }

    // Werkelijk product verwijderen
    if (target.closest('.js-remove-product')) {
      const removeBtn = target.closest('.js-remove-product');
      const id = removeBtn.getAttribute('data-id');
      const time = removeBtn.getAttribute('data-time');
      const productElem = document.querySelector(`.quotation-product[data-id="${id}"][data-time="${time}"]`);
      if (productElem) {
        productElem.remove();
      }
      removeProductFromCookie(id, time);
      const dialog = removeBtn.closest('dialog');
      if (dialog) dialog.close();

      if (document.querySelectorAll('.quotation-product').length === 0) {
        document.cookie = "gx_quotation=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.reload();
      }
      return;
    }

    // Input selectie (bijvoorbeeld kleur- of drukkeuze)
    const inputItem = target.closest('[class^="input__"] li');
    if (inputItem) {
      if (inputItem.classList.contains('is-disabled')) {
        e.preventDefault();
        return;
      }
      const parentList = inputItem.closest('[class^="input__"]');
      if (parentList && parentList.classList.contains('input__color')) {
        if (!inputItem.classList.contains('is-selected')) {
          handleProductColorSelection(e);
        }
      }
      parentList.querySelectorAll('li').forEach(el => el.classList.remove('is-selected'));
      inputItem.classList.add('is-selected');      
    }

    // Click-afhandeling voor drukopties, zij-kleuren, preprint, etc.
    if (
      target.closest('.input__side-colors li') ||
      target.closest('.input__preprint li') ||
      target.closest('.input__print-equal li') ||
      target.closest('.input__print-type li') ||
      target.closest('.input__print-dtf-format li') ||
      target.closest('.input__sides li')
    ) {
      setAjaxBusy('start');
      handlePrintTypesFormatAndColors();
      handlePriceTable();
      setAjaxBusy('end');
      return;
    }
  });

  // Afhandeling voor hoeveelheid (keyup en change) met debounce
  const quantityInput = document.querySelector('.js-product-quantity');
  if (quantityInput) {
    const debounce = (callback, wait) => {
      let timeoutId = null;
      return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => callback.apply(null, args), wait);
      };
    };

    quantityInput.addEventListener('change', () => {
      handleQuantity();
    });
  }

  // Popstate afhandeling voor productkleur selectie
  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.id) {
      handleProductColorSelection(e, true);
      document.querySelectorAll('.input__color li').forEach(el => el.classList.remove('is-selected'));
      const target = document.querySelector(`.input__color li[data-product-id="${e.state.id}"]`);
      if (target) target.classList.add('is-selected');
    } else {
      const firstItem = document.querySelector('.input__color li:first-child');
      if (firstItem) {
        const lastState = { state: { id: firstItem.getAttribute('data-product-id') } };
        handleProductColorSelection(lastState, true);
        document.querySelectorAll('.input__color li').forEach(el => el.classList.remove('is-selected'));
        const target = document.querySelector(`.input__color li[data-product-id="${lastState.state.id}"]`);
        if (target) target.classList.add('is-selected');
      }
    }
  });

  // --- Functie definities ---

  function handlePrintTypesFormatAndColors() {
    const sidesElem = document.querySelector('.input__sides li.is-selected');
    const sides = sidesElem ? parseInt(sidesElem.getAttribute('data-sides')) : 0;
    const printTypeElem = document.querySelector('.input__print-type');
    const printFormatElem = document.querySelector('.input__print-format');
    const selectedPrintType = printTypeElem && printTypeElem.style.display !== 'none' && printTypeElem.querySelector('li.is-selected')
      ? printTypeElem.querySelector('li.is-selected').getAttribute('data-print-type')
      : undefined;

    if (sides > 0) {
      if (printTypeElem) printTypeElem.style.display = 'block';
      if (printFormatElem) printFormatElem.style.display = 'block';
    } else {
      if (printTypeElem) {
        printTypeElem.style.display = 'none';
        const active = printTypeElem.querySelector('li.is-selected');
        if (active) active.classList.remove('is-selected');
      }
      if (printFormatElem) printFormatElem.style.display = 'none';
    }

    if (selectedPrintType && selectedPrintType === 'zeefdruk') {
      document.querySelector('.js-product-preprint').style.display = 'block';
      if (sides === 1) {
        document.querySelector('.js-side-colors-one').style.display = 'block';
        document.querySelector('.js-side-colors-two').style.display = 'none';
      } else if (sides === 2) {
        document.querySelector('.js-side-colors-one').style.display = 'block';
        document.querySelector('.js-side-colors-two').style.display = 'block';
      } else {
        document.querySelector('.js-side-colors-one').style.display = 'none';
        document.querySelector('.js-side-colors-two').style.display = 'none';
        document.querySelector('.js-product-preprint').style.display = 'none';
      }
    } else {
      const sideColorsOneElem = document.querySelector('.js-side-colors-one');
      const sideColorsTwoElem = document.querySelector('.js-side-colors-two');
      if (sideColorsOneElem) {
        sideColorsOneElem.style.display = 'none';
        sideColorsOneElem.querySelectorAll('li').forEach(el => el.classList.remove('is-selected'));
      }
      if (sideColorsTwoElem) {
        sideColorsTwoElem.style.display = 'none';
        sideColorsTwoElem.querySelectorAll('li').forEach(el => el.classList.remove('is-selected'));
      }
      document.querySelector('.js-product-preprint').style.display = 'none';
    }

    if (sides > 0 && selectedPrintType && selectedPrintType === 'dtf') {
      if (sides === 1) {
        document.querySelector('.js-dtf-format-one').style.display = 'block';
        document.querySelector('.js-dtf-format-two').style.display = 'none';
      } else {
        document.querySelector('.js-dtf-format-one').style.display = 'block';
        document.querySelector('.js-dtf-format-two').style.display = 'block';
      }
    } else {
      document.querySelector('.js-dtf-format-one').style.display = 'none';
      document.querySelector('.js-dtf-format-two').style.display = 'none';
    }

    handlePreprint();
    handlePrintEqual();
  }

  function handlePriceTable() {
    const sidesElem = document.querySelector('.input__sides li.is-selected');
    const sides = sidesElem ? parseInt(sidesElem.getAttribute('data-sides')) : 0;
    const printTypeElem = document.querySelector('.input__print-type li.is-selected');
    const selectedPrintType = printTypeElem ? printTypeElem.getAttribute('data-print-type') : false;
    const quantity = document.querySelector('.js-product-quantity') ? parseInt(document.querySelector('.js-product-quantity').value) : 0;
    if (quantity > 0) {
      if (sides === 0) {
        getPriceTable();
      } else if (selectedPrintType === 'dtf') {
        getPriceTable();
      } else if (selectedPrintType === 'zeefdruk') {
        const sideColorsOneElem = document.querySelector('.js-side-colors-one li.is-selected');
        const sideColorsTwoElem = document.querySelector('.js-side-colors-two li.is-selected');
        const sideColorsOne = sideColorsOneElem ? parseInt(sideColorsOneElem.getAttribute('data-side-colors-one')) : 0;
        const sideColorsTwo = sideColorsTwoElem ? parseInt(sideColorsTwoElem.getAttribute('data-side-colors-two')) : 0;
        if (sides === 2) {
          if (sideColorsTwo > 0 && sideColorsOne > 0) {
            getPriceTable();
          }
        } else if (sideColorsOne > 0) {
          getPriceTable();
        }
      }
    }
  }

  function handlePreprint() {
    const prePrint = document.querySelector('.input__preprint');
    const printSideSelected = document.querySelector('.input__sides li[data-sides="1"].is-selected') || document.querySelector('.input__sides li[data-sides="2"].is-selected');
    if (!prePrint) return;

    const sideColorsOneElem = document.querySelector('.js-side-colors-one li.is-selected');
    const sideColorsTwoElem = document.querySelector('.js-side-colors-two li.is-selected');
    const sideColorsOne = sideColorsOneElem ? parseInt(sideColorsOneElem.getAttribute('data-side-colors-one')) : 0;
    const sideColorsTwo = sideColorsTwoElem ? parseInt(sideColorsTwoElem.getAttribute('data-side-colors-two')) : 0;
    const printTypeElem = document.querySelector('.input__print-type li.is-selected');
    const printType = printTypeElem ? printTypeElem.getAttribute('data-print-type') : undefined;

    if (document.querySelector('.js-side-colors-two') && document.querySelector('.js-side-colors-two').style.display !== 'none') {
      if (printSideSelected && (sideColorsOne > 0 && sideColorsOne < 3) && (sideColorsTwo > 0 && sideColorsTwo < 3) && printType !== 'dtf') {
        prePrint.style.display = 'block';
      } else {
        prePrint.style.display = 'none';
      }
    } else {
      if (printSideSelected && (sideColorsOne > 0 && sideColorsOne < 3) && printType !== 'dtf') {
        prePrint.style.display = 'block';
      } else {
        prePrint.style.display = 'none';
      }
    }
    if (!printType) prePrint.style.display = 'none';
  }

  function handlePrintEqual() {
    const sideTwo = document.querySelector('.input__sides li[data-sides="2"].is-selected');
    const sideColorsOneElem = document.querySelector('.js-side-colors-one li.is-selected');
    const sideColorsTwoElem = document.querySelector('.js-side-colors-two li.is-selected');
    const printTypeElem = document.querySelector('.input__print-type li.is-selected');
    const printType = printTypeElem ? printTypeElem.getAttribute('data-print-type') : undefined;
    if (sideTwo && sideColorsOneElem && sideColorsTwoElem) {
      if (sideColorsOneElem.getAttribute('data-side-colors-one') === sideColorsTwoElem.getAttribute('data-side-colors-two')) {
        document.querySelector('.js-print-equal').style.display = 'block';
      } else {
        document.querySelector('.js-print-equal').style.display = 'none';
      }
    } else {
      document.querySelector('.js-print-equal').style.display = 'none';
    }
    if (printType === 'dtf') {
      document.querySelector('.js-print-equal').style.display = 'none';
    }
    if (!printType) {
      document.querySelector('.js-print-equal').style.display = 'none';
    }
  }

  // Vereenvoudigde versie; oude en uitgecommentarieerde code is verwijderd
  function handleProductColorSelection(e, popState) {
    // Implementeer de logica voor kleurselectie indien nodig
  }

  function getProductData() {
    let updateObj = {};
    const productElem = document.querySelector('.input__color') ? document.querySelector('.input__color li.is-selected') : null;
    const productId = productElem ? parseInt(productElem.getAttribute('data-product-id')) : parseInt(document.querySelector('.product-details').getAttribute('data-id'));
    const productName = document.querySelector('.product_title') ? document.querySelector('.product_title').textContent : '';
    const productSKU = document.querySelector('.product_sku') ? document.querySelector('.product_sku').textContent : '';
    const sidesElem = document.querySelector('.input__sides li.is-selected');
    const sidesPrinted = sidesElem ? parseInt(sidesElem.getAttribute('data-sides')) : 0;
    const dtfFormatOneElem = document.querySelector('.js-dtf-format-one');
    const dtfFormatOne = dtfFormatOneElem && dtfFormatOneElem.style.display !== 'none' && dtfFormatOneElem.querySelector('li.is-selected')
      ? dtfFormatOneElem.querySelector('li.is-selected').getAttribute('data-print-dtf-format')
      : undefined;
    const dtfFormatTwoElem = document.querySelector('.js-dtf-format-two');
    const dtfFormatTwo = dtfFormatTwoElem && dtfFormatTwoElem.style.display !== 'none' && dtfFormatTwoElem.querySelector('li.is-selected')
      ? dtfFormatTwoElem.querySelector('li.is-selected').getAttribute('data-print-dtf-format')
      : undefined;
    const printTypeElem = document.querySelector('.input__print-type');
    const printType = printTypeElem && printTypeElem.style.display !== 'none' && printTypeElem.querySelector('li.is-selected')
      ? printTypeElem.querySelector('li.is-selected').getAttribute('data-print-type')
      : undefined;
    const prePrintElem = document.querySelector('.input__preprint');
    const prePrint = prePrintElem && prePrintElem.style.display !== 'none' && prePrintElem.querySelector('li.is-selected')
      ? parseInt(prePrintElem.querySelector('li.is-selected').getAttribute('data-preprint'))
      : undefined;
    const printEqualElem = document.querySelector('.input__print-equal');
    const printEqual = printEqualElem && printEqualElem.style.display !== 'none' && printEqualElem.querySelector('li.is-selected')
      ? parseInt(printEqualElem.querySelector('li.is-selected').getAttribute('data-print-equal'))
      : undefined;
    const sideColorsOneElem = document.querySelector('.js-side-colors-one');
    const colorsOne = sideColorsOneElem && sideColorsOneElem.style.display !== 'none' && sideColorsOneElem.querySelector('li.is-selected') && parseInt(sideColorsOneElem.querySelector('li.is-selected').getAttribute('data-side-colors-one')) > 0
      ? parseInt(sideColorsOneElem.querySelector('li.is-selected').getAttribute('data-side-colors-one'))
      : undefined;
    const sideColorsTwoElem = document.querySelector('.js-side-colors-two');
    const colorsTwo = sideColorsTwoElem && sideColorsTwoElem.style.display !== 'none' && sideColorsTwoElem.querySelector('li.is-selected') && parseInt(sideColorsTwoElem.querySelector('li.is-selected').getAttribute('data-side-colors-two')) > 0
      ? parseInt(sideColorsTwoElem.querySelector('li.is-selected').getAttribute('data-side-colors-two'))
      : undefined;
    const quantityElem = document.querySelector('.js-product-quantity');
    const quantity = quantityElem && quantityElem.value ? parseInt(quantityElem.value) : undefined;
    const totalpriceElem = document.querySelector('.js-product-price-total span.prices-allin');
    const unitpriceElem = document.querySelector('.js-product-price-total span.prices-unitprice');
    const presscostsElem = document.querySelector('.js-product-price-total span.prices-presscosts');
    const setupcostsElem = document.querySelector('.js-product-price-total span.prices-setupcosts');
    const totalprice = totalpriceElem && totalpriceElem.textContent ? totalpriceElem.textContent : 0;
    const unitprice = unitpriceElem && unitpriceElem.textContent ? unitpriceElem.textContent : 0;
    const presscosts = presscostsElem && presscostsElem.textContent ? presscostsElem.textContent : 0;
    const setupcosts = setupcostsElem && setupcostsElem.textContent ? setupcostsElem.textContent : 0;

    updateObj.product_id = productId;
    updateObj.product_name = productName;
    updateObj.product_sku = productSKU;
    updateObj.sides_printed = sidesPrinted;
    updateObj.preprint = prePrint;
    updateObj.print_type = printType;
    updateObj.print_dtf_format_one = dtfFormatOne;
    updateObj.print_dtf_format_two = dtfFormatTwo;
    updateObj.colors_one = colorsOne;
    updateObj.colors_two = colorsTwo;
    updateObj.print_equal = printEqual;
    updateObj.quantity = quantity;
    updateObj.id = `${productId}`;
    updateObj.time = Date.now();
    updateObj.totalprice = convertNumber(totalprice);
    updateObj.unitprice = convertNumber(unitprice);
    updateObj.presscosts = convertNumber(presscosts);
    updateObj.setupcosts = convertNumber(setupcosts);

    return updateObj;
  }

  function convertNumber(input) {    
    if (input !== 0) {
        return parseFloat(input.replace(/\./g, '').replace(',', '.'));
    }
  }

  function handleProduct() {
    let errors = false;
    const quantityElem = document.querySelector('.js-product-quantity');
    if (!quantityElem || !quantityElem.value) {
      if (quantityElem) quantityElem.classList.add('has-error');
      showError('Er is geen aantal opgegeven.');
      errors = true;
    }
    const sidesElem = document.querySelector('.input__sides');
    if (sidesElem && !sidesElem.querySelector('li.is-selected')) {
      showError('Er is geen bedrukte zijde geselecteerd.');
      errors = true;
    }
    const sidesPrintedElem = document.querySelector('.input__sides li.is-selected');
    const sidesPrinted = sidesPrintedElem ? parseInt(sidesPrintedElem.getAttribute('data-sides')) : 0;
    const printFormatElem = document.querySelector('.input__print-format');
    if (printFormatElem && sidesPrinted > 0 && !printFormatElem.querySelector('li.is-selected')) {
      showError('Er is geen drukformaat geselecteerd.');
      errors = true;
    }
    const printTypeElem = document.querySelector('.input__print-type');
    if (printTypeElem && sidesPrinted > 0 && !printTypeElem.querySelector('li.is-selected')) {
      showError('Er is geen druktechniek geselecteerd.');
      errors = true;
    }
    const dtfFormatOneElem = document.querySelector('.js-dtf-format-one');
    if (dtfFormatOneElem && dtfFormatOneElem.style.display !== 'none' && sidesPrinted > 0 && !dtfFormatOneElem.querySelector('li.is-selected')) {
      showError('Er is geen drukformaat geselecteerd voor de voorkant');
      errors = true;
    }
    const dtfFormatTwoElem = document.querySelector('.js-dtf-format-two');
    if (dtfFormatTwoElem && dtfFormatTwoElem.style.display !== 'none' && sidesPrinted > 0 && !dtfFormatTwoElem.querySelector('li.is-selected')) {
      showError('Er is geen drukformaat geselecteerd voor de achterkant');
      errors = true;
    }
    const sideColorsOneElem = document.querySelector('.js-side-colors-one');
    if (sideColorsOneElem && sideColorsOneElem.style.display !== 'none' && sidesPrinted > 0 && !sideColorsOneElem.querySelector('li.is-selected')) {
      showError('Er is geen aantal kleuren geselecteerd voor de voorkant');
      errors = true;
    }
    const sideColorsTwoElem = document.querySelector('.js-side-colors-two');
    if (sideColorsTwoElem && sideColorsTwoElem.style.display !== 'none' && sidesPrinted > 0 && !sideColorsTwoElem.querySelector('li.is-selected')) {
      showError('Er is geen aantal kleuren geselecteerd voor de achterkant');
      errors = true;
    }
    const preprintElem = document.querySelector('.input__preprint');
    if (preprintElem && preprintElem.style.display !== 'none' && sidesPrinted > 0 && !preprintElem.querySelector('li.is-selected')) {
      showError('Er is geen voordruk geselecteerd');
      errors = true;
    }
    const printEqualElem = document.querySelector('.input__print-equal');
    if (printEqualElem && printEqualElem.style.display !== 'none' && sidesPrinted > 0 && !printEqualElem.querySelector('li.is-selected')) {
      showError('Er is geen keuze gemaakt voor een gelijk motief');
      errors = true;
    }
    return errors;
  }

  

  function handleQuantity() {
    let formData = new FormData();
    formData.append('action', 'update_product_quantity');
    formData.append('id', parseInt(document.querySelector('.product-details').getAttribute('data-id')));
    formData.append('quantity', parseInt(document.querySelector('.js-product-quantity').value));
    setAjaxBusy('start');
    fetch(adminUrl, {
      method: 'post',
      body: formData,
    })
      .then(response => response.text())
      .then(() => {
        getPriceTable();
      })
      .catch(response => console.log(response))
      .finally(() => setAjaxBusy('end'));
  }

  function getPriceTable(e) {
    document.querySelector('.js-product-price-table').style.display = 'none';
    document.querySelector('.js-product-price-total').style.display = 'none';
    let formData1 = new FormData();
    formData1.append('action', 'get_product_price_table');
    if (e === undefined) {
      formData1.append('id', parseInt(document.querySelector('.product-details').getAttribute('data-id')));
    } else {
      formData1.append('id', e.state && e.state.id ? e.state.id : e.target.closest('.input__color li').getAttribute('data-product-id'));
    }
    formData1.append('quantity', parseInt(document.querySelector('.js-product-quantity').value));
    formData1.append('print_dtf_format_one', document.querySelector('.js-dtf-format-one').style.display !== 'none' ? (parseInt(document.querySelector('.js-dtf-format-one li.is-selected').getAttribute('data-print-dtf-format')) || 0) : 0);
    formData1.append('print_dtf_format_two', document.querySelector('.js-dtf-format-two').style.display !== 'none' ? (parseInt(document.querySelector('.js-dtf-format-two li.is-selected').getAttribute('data-print-dtf-format')) || 0) : 0);
    formData1.append('colors_one', document.querySelector('.js-side-colors-one').style.display !== 'none' ? (parseInt(document.querySelector('.js-side-colors-one li.is-selected').getAttribute('data-side-colors-one')) || 0) : 0);
    //formData1.append('colors_two', document.querySelector('.js-side-colors-two').style.display !== 'none' ? (parseInt(document.querySelector('.js-side-colors-two li.is-selected').getAttribute('data-side-colors-two')) || 0) : 0);
    const sideColorsTwoElem = document.querySelector('.js-side-colors-two li.is-selected');
const colorsTwo = document.querySelector('.js-side-colors-two')?.style.display !== 'none' && sideColorsTwoElem
    ? parseInt(sideColorsTwoElem.getAttribute('data-side-colors-two')) || 0
    : 0;

  formData1.append('colors_two', colorsTwo);
    formData1.append('preprint', document.querySelector('.js-preprint') && document.querySelector('.js-preprint').style.display !== 'none' ? (parseInt(document.querySelector('.js-preprint li.is-selected').getAttribute('data-preprint')) || 0) : 0);
    formData1.append('print_equal', document.querySelector('.js-print-equal').style.display !== 'none' ? (parseInt(document.querySelector('.js-print-equal li.is-selected').getAttribute('data-print-equal')) || 0) : 0);
    formData1.append('print_type', document.querySelector('.input__print-type') && document.querySelector('.input__print-type').style.display !== 'none' ? document.querySelector('.input__print-type li.is-selected').getAttribute('data-print-type') : 0);
    formData1.append('sides_printed', document.querySelector('.input__sides li.is-selected') ? parseInt(document.querySelector('.input__sides li.is-selected').getAttribute('data-sides')) : 0);
    setAjaxBusy('start');
    fetch(adminUrl, {
      method: 'post',
      body: formData1,
    })
      .then(response => response.text())
      .then(response => {
        if (response != 0) {
          response = JSON.parse(response);
          const priceTableElem = document.querySelector('.js-product-price-table');
          const totalPriceElem = document.querySelector('.js-product-price-total');
          if (priceTableElem && totalPriceElem) {
            priceTableElem.innerHTML = response.table;
            priceTableElem.style.display = 'flex';
            totalPriceElem.innerHTML = response.totalprice;
            totalPriceElem.style.display = 'flex';
          }
        }
      })
      .catch(response => console.log(response))
      .finally(() => setAjaxBusy('end'));
  }

  // Afhandeling voor add-to-cart actie
  document.addEventListener('click', (e) => {
    if (!e.target.closest('#add_to_cart')) return;
    if (!handleProduct()) {
      document.querySelector('.js-product-quantity').classList.remove('has-error');
      const object = getProductData();
      let formData = new FormData();
      formData.append('action', 'add_to_cart');
      formData.append('id', parseInt(object.product_id));
      formData.append('quantity', parseInt(document.querySelector('.js-product-quantity').value));
      formData.append('data', JSON.stringify(object));
      const attachmentInput = document.querySelector('.js-product-attachment input');
      if (attachmentInput) {
        formData.append('attachment', attachmentInput.files[0]);
      }
      fetch(adminUrl, {
        method: 'post',
        body: formData,
      })
        .then(response => response.text())
        .then(response => {
          if (response) {
            response = JSON.parse(response);
            if (response.addtocart === true) {
              window.location.href = '/winkelwagen';
            } else {
              showError(response.message);
             }        
          }
        })
        .catch(response => console.log(response));
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.edit-button');
  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const target = this.getAttribute('data-target');
      document.getElementById(target + '-summary').style.display = 'none';
      document.getElementById(target + '-fields').style.display = 'block';
    });
  });
});
} 
})();

jQuery(function($){
  if ($('#afleverdatum').length) {
    $('#afleverdatum').datepicker({
        dateFormat: 'dd-mm-yy',
        minDate: 1 // voorkomt het kiezen van vandaag of verleden
    });
  }
    
});

